import { action } from 'mobx';
import { request } from 'utils/api';
import BaseStore from './BaseStore';

export default class AppearancesStore extends BaseStore {
  @action
  getByDate(date, venueId) {
    return request({
      method: 'GET',
      path: `/1/appearance?date=${date}&venueId=${venueId}`,
    });
  }

  @action
  getCharacters(statusKey = 'getCharacters') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'GET',
      path: '/1/appearance/characters',
    })
      .then(({ data }) => {
        status.success();
        return data;
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }

  @action
  getCharacterIPs(statusKey = 'getCharacterIPs') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'GET',
      path: '/1/appearance/ips',
    })
      .then(({ data }) => {
        status.success();
        return data;
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }
}
